const product = [
  {
    name: 'TskSelectNeedle',
    usDesc: 'TSK Select™ Needle',
    src: require("@/assets/images/product10.jpg"),
  },
  {
    name: 'STERiGLIDE',
    usDesc: 'TSK STERiGLIDE® Cannula',
    src: require("@/assets/images/product9.jpg"),
  },
  {
    name: 'STERiJECT',
    usDesc: 'TSK STERiJECT™ Hypodermic Needle',
    src: require("@/assets/images/product8.jpg"),
  },
  {
    name: 'TSKSyringe',
    usDesc: 'TSK Syringe',
    src: require("@/assets/images/TSY.jpg"),
  },
]

export default product